/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon24Regular = forwardRef('NetConnectRssIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.55 6.09a12.75 12.75 0 0 0-5.258-.82.75.75 0 1 1-.083-1.498 14.25 14.25 0 0 1 15.019 15.019.75.75 0 1 1-1.498-.083 12.75 12.75 0 0 0-8.18-12.619Z" }),
        React.createElement("path", { d: "M8.077 12.105a6.25 6.25 0 0 0-2.747-.319.75.75 0 0 1-.16-1.491 7.75 7.75 0 0 1 8.536 8.529.75.75 0 1 1-1.491-.16 6.25 6.25 0 0 0-4.138-6.559Z" }),
        React.createElement("path", { d: "M6 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
